export default __webpack_public_path__ + "static/Plots0032-c0726aa85f718c36e74fdf9d8de2f200.jpg";